// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.job-preview__inter .inter-info__avatar-cont {\n  margin-left: 15px;\n}\n.job-preview__inter .inter-info__info-cont {\n  margin-top: 10px;\n}\n.job-preview__inter .inter-info__data-cont {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.job-preview-modal .sk-modal__close-btn {\n  top: 10px;\n  right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
